import { connect } from 'react-redux';
import { getTierCount } from '../../../../publicSession/selectors';
const mapStateToProps = (state)=>({
        hasSubscriptions: getTierCount(state) > 0
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=UserMenuButton.container.js.map